import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { GET_ADMIN_USERS_LIST_REQUEST } from './UsersList.constant';
import {
  IGetAdminUsersListRequest,
  IGetAdminUsersResponse,
} from './UsersList.type';
import {
  getAdminUsersListFailure,
  getAdminUsersListSuccess,
} from './UsersList.action';
import { UsersApi } from 'services';

function* workerGetAdminUsersList({ payload }: IGetAdminUsersListRequest) {
  try {
    const data: { data: IGetAdminUsersResponse } = yield call(
      UsersApi.getList,
      payload,
    );

    yield put(getAdminUsersListSuccess(data.data));
  } catch (error) {
    yield put(getAdminUsersListFailure(error));
  }
}

function* watchGetAdminUsersList() {
  yield takeLatest(GET_ADMIN_USERS_LIST_REQUEST, workerGetAdminUsersList);
}

export const adminUsersListWatchers = [fork(watchGetAdminUsersList)];
